import React from "react";
import { Box, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

type LegalLinksProps = {
  centered?: boolean;
};

export default function LegalLinks({ centered = false }: LegalLinksProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: centered ? "center" : "flex-start",
        gap: 1,
        flexWrap: "wrap",
      }}
    >
      <Link component={RouterLink} to="/terms" underline="hover" color="inherit" sx={{ fontSize: "0.78rem" }}>
        Terms of Use
      </Link>
      <Typography component="span" sx={{ fontSize: "0.72rem", opacity: 0.65 }}>
        |
      </Typography>
      <Link component={RouterLink} to="/privacy" underline="hover" color="inherit" sx={{ fontSize: "0.78rem" }}>
        Privacy Policy
      </Link>
      <Typography component="span" sx={{ fontSize: "0.72rem", opacity: 0.65 }}>
        |
      </Typography>
      <Link component={RouterLink} to="/prompt-commands" underline="hover" color="inherit" sx={{ fontSize: "0.78rem" }}>
        Prompt Commands
      </Link>
    </Box>
  );
}